var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeaderboard3Rd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0567 15.0383L19.8242 24.9853C19.844 25.1025 19.8276 25.2228 19.7771 25.3304C19.7266 25.4379 19.6445 25.5275 19.5418 25.5871C19.439 25.6467 19.3205 25.6735 19.2021 25.664C19.0837 25.6544 18.9711 25.609 18.8792 25.5337L14.7025 22.3988C14.5009 22.2482 14.256 22.1668 14.0043 22.1668C13.7526 22.1668 13.5077 22.2482 13.306 22.3988L9.12236 25.5325C9.03057 25.6077 8.91804 25.6531 8.79978 25.6626C8.68151 25.6722 8.56315 25.6455 8.46047 25.586C8.35779 25.5266 8.27569 25.4372 8.2251 25.3299C8.17452 25.2226 8.15787 25.1024 8.17736 24.9853L9.9437 15.0383",
    stroke: "#CD7F32",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.3333C17.866 16.3333 21 13.1992 21 9.33325C21 5.46726 17.866 2.33325 14 2.33325C10.134 2.33325 7 5.46726 7 9.33325C7 13.1992 10.134 16.3333 14 16.3333Z",
    stroke: "#CD7F32",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaderboard3Rd);
export default __webpack_public_path__ + "static/media/icon-leaderboard-3rd.267505670415d0a5e10cdb2d98e5b9f3.svg";
export { ForwardRef as ReactComponent };